module.exports = __webpack_public_path__ + "07cfba778db042409791eed2a6d65f58.png";